



























































































































































































































































































import { Vue, Component, Prop, Ref } from "vue-property-decorator";
import { ContactData } from "@/components/Form.vue";
import Exclamation from "@/components/Icons/Exclamation.vue";

import { ValidationProvider } from "vee-validate";
import { extend } from "vee-validate";
import { required, digits, max, numeric } from "vee-validate/dist/rules";
import PhoneNumber from "awesome-phonenumber";
import countries, { LocalizedCountryNames } from "i18n-iso-countries";
// eslint-disable-next-line @typescript-eslint/no-var-requires
countries.registerLocale(require("i18n-iso-countries/langs/en.json"));
// eslint-disable-next-line @typescript-eslint/no-var-requires
countries.registerLocale(require("i18n-iso-countries/langs/de.json"));

extend("required", required);
extend("max", max);
extend("numeric", numeric);
extend("digits", digits);
extend("phone", {
  validate(value) {
    return new Promise(resolve => {
      if ((value as string).includes("+") || (value as string).startsWith("00")) {
        const phone = new PhoneNumber(value);
        resolve({ valid: phone.isValid() });
      } else {
        const phone = new PhoneNumber(value, "de");
        resolve({ valid: phone.isValid() });
      }
    });
  },
});

extend("symbols", {
  validate(value) {
    return new Promise(resolve => {
      const str = value as string;
      const valid = !(str.includes(";") || str.includes("%") || str.includes("@"));
      resolve({ valid });
    });
  },
});

@Component({ components: { ValidationProvider, Exclamation } })
export default class PersonalData extends Vue {
  @Prop({}) private readonly value!: ContactData;
  @Prop({ default: true }) private readonly showOtherFormFields!: boolean;

  @Ref() readonly firstName!: HTMLInputElement;
  @Ref() readonly lastName!: HTMLInputElement;
  @Ref() readonly street?: HTMLInputElement;
  @Ref() readonly city?: HTMLInputElement;
  @Ref() readonly postalCode?: HTMLInputElement;
  @Ref() readonly countryCode?: HTMLInputElement;
  @Ref() readonly telephone?: HTMLInputElement;

  updateInput() {
    let postalCode: string | null = null;

    if (this.postalCode && this.postalCode.value.trim().length > 0) {
      postalCode = this.postalCode.value;
    } else {
      postalCode = null;
    }

    this.$emit("input", {
      firstName: this.firstName.value || null,
      lastName: this.lastName.value || null,
      street: this.street?.value || null,
      city: this.city?.value || null,
      postalCode: postalCode,
      telephone: this.telephone?.value,
      countryCode: this.countryCode?.value,
    });
  }

  get countryCodes(): LocalizedCountryNames {
    return countries.getNames(this.$i18n.locale);
  }
}
